var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 105,
    viewBox: "0 0 50 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7321 102.925C0.577367 101.542 0 99.9035 0 98.0111C0 96.1223 0.577367 94.4862 1.7321 93.1028L35.5658 52.5692L1.61663 11.8972C0.538876 10.6061 0 8.99209 0 7.05534C0 5.11858 0.577367 3.4585 1.7321 2.0751C2.88684 0.6917 4.25404 0 5.83372 0C7.41032 0 8.77598 0.6917 9.93072 2.0751L48.7298 48.6957C49.1917 49.249 49.5196 49.8485 49.7136 50.4941C49.9045 51.1397 50 51.8314 50 52.5692C50 53.307 49.9045 53.9987 49.7136 54.6443C49.5196 55.2899 49.1917 55.8893 48.7298 56.4427L9.81524 103.063C8.73749 104.354 7.41032 105 5.83372 105C4.25404 105 2.88684 104.308 1.7321 102.925Z",
    fill: "#1C82AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/arrowRightBlue.5c0c3a9c0ea458efacaca8e4ba4bc829.svg";
export { ForwardRef as ReactComponent };